import { ArrowUpRight, Truck, Hammer, Wrench, Recycle, Home as HomeIcon, Sofa } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    id: "junk",
    span: "md:col-span-8 md:row-span-2",
    tall: true,
    title: "Full Property & Estate Cleanouts",
    tag: "Junk Removal",
    body: "Single item to full-house / garage / yard clearouts. Trucks staged for same-day dispatch. We separate donations from landfill.",
    price: "From $95",
    img: "https://images.unsplash.com/photo-1612145342813-849b0c3e7f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: Truck,
  },
  {
    id: "drywall",
    span: "md:col-span-4 md:row-span-2",
    tall: true,
    title: "Drywall & Wall Surgery",
    tag: "Home Repair",
    body: "Doorknob holes, fist punches, plumbing patches. Textured, primed, painted to match — you won't find it later.",
    price: "From $110",
    img: "https://images.unsplash.com/photo-1623161551727-54c918bdcec1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: Wrench,
  },
  {
    id: "furniture",
    span: "md:col-span-4",
    title: "IKEA & Flat-Pack Assembly",
    tag: "Assembly",
    body: "Pax, Malm, Kallax, cribs, desks. Boxes disappear, everything wall-anchored.",
    price: "From $79",
    img: "https://images.unsplash.com/photo-1731168273756-e02cae42265b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: Hammer,
  },
  {
    id: "handyman",
    span: "md:col-span-4",
    title: "Minor Home Upgrades",
    tag: "Handyman",
    body: "Fixture swaps, TV mounts, shelving, caulk, sealing, gutter cleanouts.",
    price: "From $89",
    img: "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: HomeIcon,
  },
  {
    id: "transport",
    span: "md:col-span-8",
    title: "Delivery & Item Transport",
    tag: "We Haul It For You",
    body: "Bought a couch on Marketplace? Need a safe moved across town? Flat $89.99 within 25 miles of 55423 — pickup to drop-off, two hands, one truck.",
    price: "Flat $89.99",
    img: "https://images.unsplash.com/photo-1600518464441-9154a4dea21b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: Truck,
  },
  {
    id: "eco",
    span: "md:col-span-4",
    title: "Eco-Recycling & Donation",
    tag: "Zero-Landfill",
    body: "70%+ of what we haul gets donated, recycled, or upcycled. Impact report emailed to you.",
    price: "Included free",
    img: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    icon: Recycle,
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div className="max-w-3xl">
            <div className="font-tactical text-[11px] uppercase tracking-[0.25em] text-[#0C2E2B] mb-2">Services</div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-zinc-900 leading-tight">
              One crew for every mess you've been putting off.
            </h2>
          </div>
          <a href="#quote" data-testid="services-quote-cta" className="text-sm font-bold text-[#0C2E2B] flex items-center gap-1 hover:underline">
            Get a photo quote <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[220px] gap-4">
          {SERVICES.map((s) => (
            <div
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`relative overflow-hidden rounded-xl border-2 border-[#0C2E2B] group card-lift ${s.span}`}
            >
              <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0C2E2B] via-[#0C2E2B]/60 to-transparent" />
              <div className="relative h-full flex flex-col justify-between p-6">
                <div className="flex items-start justify-between">
                  <div className="inline-flex items-center gap-1.5 bg-[#FFDF00] text-[#0C2E2B] text-[10px] font-tactical uppercase tracking-widest px-2 py-1 rounded">
                    <s.icon className="w-3 h-3" /> {s.tag}
                  </div>
                  <span className="font-mono-data font-bold text-xs text-white bg-black/40 backdrop-blur px-2 py-1 rounded">{s.price}</span>
                </div>
                <div>
                  <h3 className={`font-display font-black text-white ${s.tall ? "text-2xl md:text-3xl" : "text-xl"} leading-tight`}>{s.title}</h3>
                  <p className="text-xs md:text-sm text-zinc-200 mt-2 max-w-md leading-relaxed">{s.body}</p>
                  {s.id === "transport" && (
                    <Link to="/furnituredepot" data-testid="services-furniture-depot-btn"
                      className="inline-flex items-center gap-1.5 mt-3 bg-[#FFDF00] text-[#0C2E2B] text-xs font-black uppercase tracking-wider px-3 py-2 rounded-md hover:bg-[#E5C900] transition-colors">
                      <Sofa className="w-3.5 h-3.5" /> Bought furniture at a partner store? Click here <ArrowUpRight className="w-3.5 h-3.5" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
